import Base from './action-base'
import renderInline from './display.pug'
import renderFullFields from './display-full.pug'
import htmlTemplates from './html-templates'
import CONDITIONS from '../trigger-editor/conditions'

export default class Display extends Base
  @DEFAULTS:
    type: "webview"

  Object.defineProperty this, "label", get: -> @t(".label")
  @icon = "fa-tv"

  @property "template", get: ->
    @HTML_TEMPLATES[@shadow._template]

  # Video previews aren't rendered yet; show a blank phone screen as a stub.
  @property "previewHtml", get: ->
    return "" if @shadow.type == "video"

    @shadow.displayHtml || ""

  constructor: (args...) ->
    super(args...)

    @HTML_TEMPLATES = htmlTemplates()

  displayHtml: ""
  iframeDirty: false

  load: =>
    if @shadow.type == "map" && @shadow.styleJSON
      @shadow.styleJSON = JSON.stringify(@shadow.styleJSON)

    if (displayAsset = @assetsManager.assetFor(@store))
      @displayHtml = @shadow.displayHtml = await displayAsset.text()
      @iframeDirty = true

  templateData: (key)->
    return unless @template
    return "" unless @shadow._templateData
    return @shadow._templateData[key] if key of @shadow._templateData

    @shadow._templateData[key] ?=
      if key of @template.domIdFields
        randomDomId(@template.domIdFields[key].type)
      else
        ""

  renderFields: renderInline
  renderFullFields: renderFullFields

  addPositionMarker: =>
    @shadow.positionMarkers.push({})

  addImageOverlay: =>
    @shadow.imageOverlays.push({})

  deletePositionMarker: (positionMarker)=>
    return if (index = @shadow.positionMarkers.indexOf(positionMarker)) == -1

    @shadow.positionMarkers.splice(index, 1)

  deleteImageOverlay: (imageOverlay)=>
    return if (index = @shadow.imageOverlays.indexOf(imageOverlay)) == -1

    @shadow.imageOverlays.splice(index, 1)

  renderFull: =>
    if @shadow.type == "map" || @shadow.type == "video"
      @shadow.imageOverlays ||= []

    if @shadow.type == "map"
      @shadow.currentLocationMarker ||= {assetId: '', size: 0}
      @shadow.positionMarkers ||= []

    super()

  updatePreviewFrame: (newIframe) =>
    return unless newIframe != @iframe || @iframeDirty

    @iframe = newIframe

    html = @previewHtml

    if html
      # this will be called before asset read
      doc = document.createElement('html')
      doc.innerHTML = html

      base = document.createElement("base")
      base.href = "#{window.location.origin}/playbooks/#{@sceneEditor.playbookEditor.playbookId}/assets/"
      doc.querySelector("head")?.prepend(base)

      html = doc.innerHTML

    blob = new Blob([html], type: "text/html")
    @iframe.src = URL.createObjectURL(blob)

    @iframeDirty = false

  onInput: =>
    oldHtml = @previewHtml

    super arguments...

    if this.template
      @shadow._templateData ||= {}
      @shadow.displayHtml = @template.render.call(this, @shadow._templateData)

    @iframeDirty = oldHtml != @previewHtml

  onSave: (newData)=>
    switch @shadow.type
      when "webview"
        if newData.displayHtml != @displayHtml
          @assetsManager.future(
            @store,
            content: newData.displayHtml,
            contentType: "text/html",
            memo: "場景網頁",
            autoDelete: true
          )
        delete newData.styleJSON

      when "map"
        try
          newData.styleJSON = JSON.parse(newData.styleJSON)

      else
        delete newData.styleJSON

    delete newData.displayHtml

  editClickCondition: (domIdField)=>
    domId = @templateData(domIdField)
    @_editRelatedCondition(domIdField, 'webviewClick', domId)

  addInputResponse: (domIdField)=>
    return unless (value = prompt(@t('.enter_value')))

    domId = @templateData(domIdField)
    @_editRelatedCondition(domIdField, 'webviewScript', "#{domId}-#{value}", " #{value}")

  # conditionId: id means domid for click, arbitrary id for script
  _editRelatedCondition: (domIdField, conditionType, conditionId, conditionNameSuffix="")=>
    relatedCondition = null

    for trigger in @sceneEditor.scene.triggers
      continue unless trigger.type == conditionType && trigger.id == conditionId

      relatedCondition = trigger
      break

    unless relatedCondition
      relatedCondition = CONDITIONS[conditionType].scaffold()
      relatedCondition._name = @templateData(@template.domIdFields[domIdField].conditionNameField) + conditionNameSuffix
      relatedCondition.id = conditionId
      @sceneEditor.scene.triggers.push(relatedCondition)

    @sceneEditor.focusTrigger(relatedCondition)
